module.exports = __webpack_public_path__ + "media/images/icon-close-white-66f94df4e541f3689eb9916c2fd21e60.svg";